import { GET_MATCHING_GENERICS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Generic {
    id: string;
    name: string;
    ingredients?: string;
    generic_info?: {
        used_for?: string[];
        prescription_required: boolean;
        therapeutic_class: string;
        safety_profile?: SafetyProfileEntity[];
        side_effects?: string[];
        related_tests?: null;
    };
}

export interface SafetyProfileEntity {
    entity: string;
    caution: string;
}

export default (text?: string): Promise<Generic[]> =>
    fetchWithRefresh(GET_MATCHING_GENERICS(encodeURIComponent(text || ''))).then((res) =>
        res.json(),
    );
